import React from 'react';

const HassleFreeReturns = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5552_33643)">
      <mask
        id="mask0_5552_33643"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5552_33643)">
        <path
          d="M17.7446 4.39453C18.1164 4.39453 18.4207 4.73256 18.4207 5.13819V18.8621C18.4207 19.2678 18.1164 19.6058 17.7446 19.6058H2.87137C2.49954 19.6058 2.19531 19.2678 2.19531 18.8621V5.13819C2.19531 4.73256 2.49954 4.39453 2.87137 4.39453H17.7446Z"
          fill="#F3FCFF"
        />
        <path
          d="M17.7452 3.04297H2.87192C1.65502 3.04297 0.84375 4.09086 0.84375 5.13874V18.8627C0.84375 19.9106 1.62121 20.9585 2.87192 20.9585H17.7452C18.9621 20.9585 19.7733 19.9106 19.7733 18.8627V5.13874C19.7733 4.09086 18.9959 3.04297 17.7452 3.04297ZM18.4212 18.8627C18.4212 19.2683 18.117 19.6063 17.7452 19.6063H2.87192C2.50009 19.6063 2.19586 19.2683 2.19586 18.8627V5.13874C2.19586 4.73311 2.50009 4.39508 2.87192 4.39508H17.7452C18.117 4.39508 18.4212 4.73311 18.4212 5.13874V18.8627Z"
          fill="#004C80"
        />
        <path
          d="M4.90039 14.3664L11.999 19.6058V9.12695L4.90039 14.3664Z"
          fill="#FF7C1F"
        />
        <path
          d="M11.9994 3.04297H8.61914V8.89086H11.9994V3.04297Z"
          fill="#004C80"
        />
        <path
          d="M19.7726 7.16662C21.6993 7.50464 23.1529 9.22859 23.1529 11.3244C23.1529 13.4201 21.3275 15.5497 19.0627 15.5497H8.92188V12.9469H19.0627C19.9416 12.9469 20.6515 12.2032 20.6515 11.3244C20.6515 10.4455 20.2796 10.1075 19.7726 9.83704V7.13281V7.16662Z"
          fill="#FF7C1F"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5552_33643">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HassleFreeReturns;
